import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from "rxjs/Rx";
import { recruitsinternships} from '../recruits-view.model'
@Injectable()
export class InternshipsService{
    public formData10: recruitsinternships;

    constructor(private http:HttpClient){

    }
    onGetRecruitsInternships(id:number): Observable<boolean> {
        
        return this.http.get(`api/recruits/getrecruitsinternships/${id}`)
            .map( (data:recruitsinternships)=>{
                this.formData10 = data;
                return true;
            });
    }
    onPostRecruitsInternshipsForm(): Observable<boolean> {                    
        return this.http.post(`api/recruits/addrecruitsinternships`, this.formData10,{
            headers:new HttpHeaders()
            .set('Content-Type','application/json')
            })
            .map(()=>{            
                return true;
            });
    }
    DeleteFile(id:number): Observable<boolean> {
        
        return this.http.get(`api/recruits/deleterecruitsinternshipsfile/${id}`)
            .map( (data:recruitsinternships)=>{
                this.formData10 = data;
                return true;
            });
    }
}